<template>

  <v-content>
    <v-form
      ref="formLogin"
      v-on:submit.prevent="login()"
    >
      <v-container
        fluid
        fill-height
        v-if="isAuth==false"
      >
        <v-layout justify-center>
          <v-flex xs8>
            <v-card
            text
              width="350"
            >
              <v-card-text>
                <v-text-field
                  prepend-icon="lock"
                  name="login"
                  label="Inserisci il codice"
                  v-model="codice"
                  required
                  :rules="[() => codice.length > 0 || 'Il campo è obbligatorio']"
                  :append-icon="show1 ? 'visibility_off' : 'visibility'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  type="submit"
                >Entra</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>

    <v-container
      fluid
      grid-list-md
      grey
      lighten-4
      v-if="isAuth"
      style="background-color:white!important;"
    >
      <v-subheader style="font-size: 18px;">Documenti scaricabili:</v-subheader>
      <v-row
        wrap
      >

        <v-flex
          xs6
          sm4
          md4
          style="padding:10px;"
          v-for="file in files"
          :key="file.Descrizione"
        >
          <v-card
            color="transparent"
            width="180"
          >
            <v-card-media
              height="230px"
              :src="file.Anteprima"
              :contain="true"
              style="cursor: pointer;"
              v-on:click="scaricaFile(file.PathFile)"
            >
            </v-card-media>

            <v-card-title
              primary-title
              class=" justify-center"
              style="height:50px; padding-left:10px!important;"
            >
              <span
                class="headline black--text "
                style="font-size: 15px!important; line-height: 1!important;"
                v-text="file.Descrizione"
              ></span>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-row>
    </v-container>

  </v-content>

</template>

<script>
import { login_doc, get_doc } from "@/api/api.doc.js";
import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  data: () => ({
    files: [],
    isAuth: false,
    codice: "",
    show1: false,
    width: 600 // Larghezza form usata in mixin
  }),

  methods: {
    login() {
      // Validazione
      if (this.$refs.formLogin.validate() == false) {
        return;
      }

      login_doc(this.codice)
        .then(res => {
          this.isAuth = true;

          // Carico i documenti
          this.getDocumenti();
        })
        .catch(err => {
          this.codice = "";
          console.log(err);
        });
    },

    getDocumenti() {
      get_doc()
        .then(res => {
          this.files = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    scaricaFile(src) {
      window.open(this.$load.getUrlDownload() + src, "_blank");
    }
  }
};
</script>
